import { useEffect, useState } from 'react';

/**
 * Returns a human-readable "x ago" string for the given ISO timestamp,
 * auto-refreshing every minute while the component is mounted.
 */
export function useRelativeTime(isoTimestamp) {
  const [label, setLabel] = useState(() => format(isoTimestamp));

  useEffect(() => {
    setLabel(format(isoTimestamp));
    const id = setInterval(() => setLabel(format(isoTimestamp)), 60_000);
    return () => clearInterval(id);
  }, [isoTimestamp]);

  return label;
}

function format(isoTimestamp) {
  if (!isoTimestamp) return '';
  const then = new Date(isoTimestamp).getTime();
  if (isNaN(then)) return '';
  const diffMs = Date.now() - then;
  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const d = Math.floor(hr / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(isoTimestamp).toLocaleDateString();
}
